import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/projects/components/ui/dialog";
import { Button } from "@/projects/components/ui/button";
import { Download } from "lucide-react";
import type { Submission } from "@/projects/lib/store";

export function VideoPlayerModal({
  submission,
  open,
  onOpenChange,
}: {
  submission: Submission | null;
  open: boolean;
  onOpenChange: (v: boolean) => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>{submission?.videoTitle ?? "Video"}</DialogTitle>
        </DialogHeader>
        <div className="aspect-video overflow-hidden rounded-lg bg-black">
          {/* Sample placeholder video */}
          <video
            controls
            className="h-full w-full"
            poster="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=1200"
          >
            <source src="https://cdn.coverr.co/videos/coverr-a-teacher-in-a-classroom-8747/1080p.mp4" type="video/mp4" />
          </video>
        </div>
        {submission && (
          <div className="mt-2 flex flex-wrap items-center justify-between gap-3 text-sm text-muted-foreground">
            <div>
              <div className="font-medium text-foreground">{submission.fileName}</div>
              <div>{submission.fileSizeMB} MB</div>
            </div>
            <Button variant="outline" size="sm">
              <Download className="mr-2 h-4 w-4" /> Download
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
